// extracted by mini-css-extract-plugin
export default {"atBlock":"AT_atBlock__u8rgQ","listBox":"AT_listBox__S34lG","decriptionBlock":"AT_decriptionBlock__OptKL","decription":"AT_decription__WXAwb"};